import endpoints from '@app/src/api/endpoints'
import { FetchKey } from '@app/src/api/fetchHooks'
import Filter from '@app/src/pages/ResourceCollection/Filters/Filter'
import FilterFacetSelect from '@app/src/pages/ResourceCollection/Filters/FilterFacetSelect'
import type { FilterGroup } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import type { FacetItem } from '@app/src/pages/ResourceCollection/index'
import { SortOrder } from '@app/src/types/filter'
import React from 'react'

interface QuestionCategoryFilterProps {
  categoryId: number
  categoryName: string
  implicitFilters: FilterGroup[] | undefined
  customSort?: (a: FacetItem, b: FacetItem) => number
}

const QuestionCategoryFilter: React.FC<QuestionCategoryFilterProps> = ({
  categoryId,
  categoryName,
  implicitFilters,
  customSort,
}) => {
  return (
    <Filter name="options.id" operator={Operators.In} uniqueId={categoryId.toString()} intersect>
      {({ value, onChange, filterName }) => (
        <FilterFacetSelect
          implicitFilters={[
            ...(implicitFilters ?? []),
            {
              name: 'options.categoryId',
              filters: [{ value: categoryId, operator: Operators.EqualTo }],
            },
          ]}
          size="small"
          multiple
          facetsParam={{
            key: [FetchKey.QuestionFacets, filterName, categoryId],
            endpoint: endpoints.questionWithFacets,
            facetsParam: [{ name: 'options.name' }],
            sort: { target: 'label', order: SortOrder.ASCENDING },
          }}
          filterName={filterName}
          onChange={onChange}
          fieldLabel={categoryName}
          value={[value].flat()}
          uniqueId={categoryId.toString()}
          customSort={customSort}
        />
      )}
    </Filter>
  )
}

export default QuestionCategoryFilter
